// storybook-check-ignore
import React from 'react';

import { Box, Text } from '@opendoor/bricks-next';
import { motion } from 'framer-motion';

import { EiChevronDownIcon } from '../../../../shared/EiChevronDownIcon';

interface MobileMegaNavButtonProps {
  itemName: string;
  onClick: () => void;
}

export const MobileMegaNavButton: React.FC<MobileMegaNavButtonProps> = ({ itemName, onClick }) => {
  const buttonProps = { onPress: onClick } as any;

  return (
    <Box tag={motion.li as any} marginBottom="$8x" $largerThanSM={{ display: 'none' }}>
      <Box
        tag="button"
        {...buttonProps}
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        padding={0}
        width="100%"
        cursor="pointer"
      >
        <Text
          tag="span"
          typography="$subheaderMedium"
          fontWeight="$medium"
          $smallerThanLG={{ typography: '$subheaderXsmall' }}
        >
          {itemName}
        </Text>
        <Box width={16} height={16} style={{ transform: 'rotate(-90deg)' }}>
          <EiChevronDownIcon />
        </Box>
      </Box>
    </Box>
  );
};
